



/**
 * Counts the number of items in an object
 * @param obj - The object to count items from
 * @returns The number of key-value pairs in the object
 */
export const countObjectItems = (obj: Record<string, any>): number => {
  if (!obj || typeof obj !== 'object') {
    return 0;
  }
  return Object.keys(obj).length;
};

